<template>
    <div class="container-fluid footer-block">
        <div class="row justify-content-center">
            <div class="col-12">

                <div class="d-flex flex-column footer-block-info">
                    <div class="d-flex flex-column flex-xl-row align-items-center position-relative">
                        <div class="col-xl-2 col-12 d-flex  brand-logo">
                            <img src="/images/logowhite1-footer.svg" class="mx-auto mx-xl-0" alt="logo_white">
                        </div>
                        <div class="col-xl-7 footer-menu col-12">
                            <div class="d-flex flex-column align-items-center justify-content-xl-center flex-xl-row">
                                <div class="d-flex">
                                    <a class="navigation-footer me-xl-5 js-change-text-home" href="/">Home</a>
                                </div>
                                <div class="js-footer-dropdown position-relative ms-5  d-flex flex-xl-column">
                                    <a class="dropdown-toggle js-dropdown-footer  position-relative ps-xl-0   py-xl-0 navigation-footer"
                                        role="button"
                                       @click.stop="closeDrop($event,'showDrop')"
                                       data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ nameBtn.services }}
                                    </a>

                                    <ul class="dropdown-menu" :class="{'active': (showDrop)}">
                                        <li v-for="option in options">
                                            <a class="dropdown-item" :href="option.link">{{ option.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="d-flex">
                                    <a class="navigation-footer me-xl-5 js-change-text-gallery" href="/gallery">Gallery</a>
                                </div>
                                <div class="js-footer-dropdown position-relative ms-5 d-flex flex-xl-column">
                                    <a class="dropdown-toggle js-dropdown-footer  position-relative ps-xl-0  py-xl-0 navigation-footer"
                                       href="#" role="button"
                                       @click.stop="closeDrop($event,'showDrop1')"
                                       data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ nameBtn.resourse }}
                                    </a>

                                    <ul class="dropdown-menu" :class="{'active': showDrop1}">
                                        <li v-for="option in optionsResourse">
                                            <a class="dropdown-item" :href="option.link">{{ option.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="d-flex">
                                    <a class="navigation-footer me-xl-5 js-change-text-contact" href="/question">Contact Us</a>
                                </div>



                            </div>

                        </div>
                        <div class="col-xl-3 col-12 d-flex flex-column mobile-social flex-xl-row justify-content-end">

                            <div class="d-xl-none mt-4 mb-4 pb-2  d-flex justify-content-center">
                                <div class="social-icon" v-for="icon in icons">
                                    <a :href="icon.href" target="_blank">
                                        <img :src="icon.src" alt="social">
                                    </a>
                                </div>
                            </div>
                            <a type="button" href="/gallery"
                               class="btn-purple btn ms-auto me-auto ms-xl-0 me-xl-0">{{ nameBtn.chooseModel }}</a>
                        </div>
                    </div>
                    <div class="d-xl-flex footer-social">
                        <div class="col-12 d-block mt-3 d-xl-flex justify-content-between align-items-center">
                            <div class="opacity-50">
                                <div >
                                    <div class="d-flex footer__info-block justify-content-center justify-content-xl-start">
                                        <p>{{ nameBtn.check }}</p>
                                        <p >| © Sketchat 2025</p>
                                    </div>
                                    <div class="d-flex footer__info-block justify-content-center justify-content-xl-start">
                                        <p >{{ footerInfo.cr.name }} : {{ footerInfo.cr.body }}</p>
                                        <p class="me-0">| {{ footerInfo.vat.name }} : {{ footerInfo.vat.body }}</p>
                                    </div>

                                </div>

                            </div>
                            <div class="ms-5 ms-xxl-5 mt-4 opacity-50 mt-xl-1 d-flex justify-content-center d-xl-block">
                                <img :src="icon.src" class="icon_logo-pay" alt="#" v-for="icon in iconsPay">
                            </div>
                            <div class="col-2 d-none d-xl-flex justify-content-end">
                                <div class="social-icon" v-for="icon in icons">
                                    <a :href="icon.href" rel="nofollow" target="_blank">
                                        <img :src="icon.src" alt="social">
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
export default {
    data() {
        return {
            footerInfo: {
                cr: {
                    name: "CR",
                    body: '1010861521',
                },
                vat: {
                    name: "VAT",
                    body: '311562321100003',
                },
            },
            showDrop: false,
            showDrop1: false,
            nameBtn: {
                resourse: '',
                services: '',
                chooseModel: '',
                check: ''
            },
            iconsPay: [
                {
                    src: '/images/icons/pay/MadaPay-White.svg',
                },
                {
                    src: '/images/icons/pay/StcPay-White.svg',
                },
                {
                    src: '/images/icons/pay/Apple-Pay-White.svg',
                },

                {
                    src: '/images/icons/pay/Visa-White.svg',
                },
                {
                    src: '/images/icons/pay/Mastercard_hrz_solid_rev.ai.svg',
                },


            ],
            icons: [
                {
                    src: '/images/icons/inst-footer.svg',
                    href: 'https://instagram.com/sketchat3d?igshid=YmMyMTA2M2Y='
                },
                {
                    src: '/images/icons/whatsapp-footer.svg',
                    href: 'https://api.whatsapp.com/send/?phone=966532717993&text&type=phone_number&app_absent=0'
                },
                {
                    src: '/images/icons/social-footer.svg',
                    href: 'https://www.tiktok.com/@sketchat3d?_t=8Yy70xblkxC&_r=1'
                },
                {
                    src: '/images/icons/twitter-footer.svg',
                    href: 'https://twitter.com/sketchat3d?s=11&t=TKjRPehBa803axBUBHOmhw'
                },
                {
                    src: '/images/icons/snapchat-footer.svg',
                    href: 'https://t.snapchat.com/uEBOfpaL'
                },
            ],
            navs: [
                {
                    title: 'Home',
                    link: '/'
                },
                {
                    title: 'Gallery ',
                    link: '/gallery'
                },
                {
                    title: 'Contact Sketchat ',
                    link: '/question'
                },
            ],
            optionsResourse: [
                {
                    name: '3D Printing Technology',
                    link: '/submit/material'
                },
                {
                    name: 'FAQs ',
                    link: '/faqs'
                },
                {
                    name: 'Privacy ',
                    link: '/privacy'
                },
            ],
            options: [
                {
                    name: 'Print your 3D model',
                    link: '/client-model'
                },
                {
                    name: 'Design & Print',
                    link: '/request-create'
                },
            ]
        }
    },

    mounted() {
        let dropdowns = document.querySelectorAll('.js-footer-dropdown')
        dropdowns.forEach(dropdown => {
            dropdown && dropdown.addEventListener('click', e => {
                e.currentTarget.querySelector('.dropdown-menu').classList.toggle('active')
            })
        })
        document.addEventListener('click',() => {
            if(this.showDrop) {
                this.showDrop = false
            } else if (this.showDrop1) {
                this.showDrop1 = false;
            }
        })
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
        liLang.forEach(li => {
            li.addEventListener('click', e => {
                this.changeContent()
            })
        })
    },

    methods: {
        closeDrop(e, drop) {
            let vm = this

            if (drop === 'showDrop1') {
                vm.showDrop1 = !vm.showDrop1
                vm.showDrop = false

            } else if (drop === 'showDrop') {
                vm.showDrop1 = false
                vm.showDrop = !vm.showDrop
            }
        },
        changeContent() {

            if (window.currentLang === 'ar-sa') {
                this.navs[0].title = 'الرئيسية'
                this.navs[1].title = 'معرض النماذج والمنتجات'
                this.navs[2].title = 'تواصل معنا'

                this.options[0].name = 'طباعة النماذج ثلاثية الأبعاد'
                this.options[1].name = 'تصميم النماذج ثلاثية الأبعاد'

                this.nameBtn.resourse = 'المصادر والمعلومات'
                this.nameBtn.services = 'الخدمات'
                this.nameBtn.chooseModel = 'تصفح معرض النماذج والمنتجات'
                this.nameBtn.check = 'جميع الحقوق محفوظة'
                this.optionsResourse[0].name = 'تقنيات الطباعة ثلاثية الأبعاد'
                this.optionsResourse[1].name = 'الأسئلة الشائعة'
                this.optionsResourse[2].name = 'الخصوصية'

                this.footerInfo.cr.name = 'السجل التجاري'
                this.footerInfo.vat.name = 'الرقم الضريبي'
            } else {
                this.footerInfo.cr.name = 'CR'
                this.footerInfo.vat.name = 'VAT'

                this.optionsResourse[0].name = '3D Printing Technology'
                this.optionsResourse[1].name = 'FAQs'
                this.optionsResourse[2].name = 'Privacy'

                this.nameBtn.resourse = 'Resources '
                this.nameBtn.services = '3D Services '
                this.nameBtn.chooseModel = 'Explore our Gallery'
                this.nameBtn.check = 'All rights reserved '


                this.options[0].name = 'Print your 3D Model'
                this.options[1].name = 'Design and Print'

                this.navs[0].title = 'Home'
                this.navs[1].title = 'Gallery'
                this.navs[2].title = 'Contact Sketchat'
            }

        }
    },
    updated() {
    }

}
</script>

<style lang="scss">
/* @import "../../sass/front/footer"; */
</style>
